// @ts-nocheck
export default {
    welcome: "स्वागत है",
    email_address: "ईमेल पता",
    email_or_phone: "ईमेल पता या फोन नंबर",
    enter_your_email: "अपना ईमेल दर्ज करें",
    enter_your_email_or_phone: "अपना ईमेल पता या फोन नंबर दर्ज करें",
    phone_placeholder: "फोन नंबर",
    password: "पासवर्ड",
    confirm_password: "पासवर्ड की पुष्टि करें",
    log_in: "लॉग इन करें",
    login: "लॉगिन",
    forgot_password: "पासवर्ड भूल गए?",
    forgot_password_title: "पासवर्ड भूल गए",
    keep_me_logged_in: "मुझे लॉग इन रखें",
    sign_in: "साइन इन करें",
    not_registered: "अभी तक पंजीकृत नहीं है?",
    create_account: "खाता बनाएं",
    sign_up: "साइन अप करें",
    first_name: "पहला नाम",
    last_name: "अंतिम नाम",
    dob_placeholder: "जन्म तिथि (DD/MM/YYYY)",
    submit: "जमा करें",
    already_have_account: "पहले से ही एक खाता है?",
    why_need_dob_title: "हमें इसकी आवश्यकता क्यों है?",
    why_need_dob_text: `इस साइट का उपयोग करके, आप प्रतिनिधित्व करते हैं, स्वीकार करते हैं, और सहमत होते हैं कि आप कम से कम 14 वर्ष के हैं, या यदि आप 18 वर्ष से कम उम्र के हैं लेकिन कम से कम 14 वर्ष के हैं (एक "नाबालिग"), तो आप साइट का उपयोग अपने माता-पिता या कानूनी अभिभावक की सहमति से कर रहे हैं और आपने अपने माता-पिता या कानूनी अभिभावक की अनुमति प्राप्त कर ली है साइट का उपयोग करने और इसकी शर्तों से सहमत होने के लिए। यदि आप एक नाबालिग के माता-पिता या कानूनी अभिभावक हैं, तो आप यहां नाबालिग को इन शर्तों से बांधने के लिए सहमत होते हैं और यदि नाबालिग इन शर्तों का उल्लंघन करता है तो कंपनी को पूरी तरह से क्षतिपूर्ति और हानि रहित रखने के लिए सहमत होते हैं। यदि आप कम से कम 14 वर्ष के नहीं हैं, तो आप किसी भी समय या किसी भी तरीके से साइट का उपयोग नहीं कर सकते हैं या कंपनी या साइट को कोई भी जानकारी प्रस्तुत नहीं कर सकते हैं। नोट: इस सॉफ़्टवेयर के कुछ उदाहरण हैं जिनके लिए उपयोगकर्ताओं को कम से कम 14 वर्ष की आयु, कम से कम 16 वर्ष की आयु, या कम से कम 18 वर्ष की आयु होनी चाहिए। यदि आप अपना जन्मदिन दर्ज करने के बाद पंजीकरण से वंचित हो जाते हैं तो इसका कारण यह है कि आप जिस विशिष्ट पोर्टल के लिए पंजीकरण कर रहे हैं उसमें इनमें से एक आवश्यकता है।`,
    go_back: "वापस जाओ",
    email_verification: "ईमेल सत्यापन",
    log_out: "लॉग आउट",
    resend_email_verification: "सत्यापन ईमेल पुनः भेजें",
    resend_text_verification: "सत्यापन टेक्स्ट पुनः भेजें",
    send_email_verification_instead: "इसके बजाय सत्यापन ईमेल भेजें",
    send_text_verification_instead: "इसके बजाय सत्यापन टेक्स्ट भेजें",
    reset_password: "पासवर्ड रीसेट करें",
    accept_invite: "निमंत्रण स्वीकार करें",
    my_hep: "मेरा होम एक्सरसाइज प्लान",
    plan_created: "योजना बनाई गई",
    remove_plan: "योजना हटाएं",
    open_plan: "इस योजना को खोलें",
    remove_plan_confirm_text: "क्या आप वाकई इस योजना को हटाना चाहते हैं?",
    duplicate_plan_check_text:
        "आपके पास पहले से ही यह योजना असाइन की गई है। क्या आप वाकई इस योजना को पुनः असाइन करना चाहते हैं?",
    duplicate_plan_modal: {
        yes_text: "हाँ",
        no_text: "डैशबोर्ड पर जाएं",
    },
    translation_disclaimer: {
        title: "अनुवाद अस्वीकरण",
        subtitle: "कृपया ध्यान दें कि हमारे अनुवाद AI सॉफ़्टवेयर द्वारा संचालित हैं, जो लगभग 98% सटीक है। स्पष्ट और सटीक संचार सुनिश्चित करने के लिए, हम अस्पष्ट या गलत प्रतीत होने वाले किसी भी अनुवाद पर स्पष्टीकरण का अनुरोध करने की सलाह देते हैं। संभावित गलतफहमियों को कम करने के लिए सरल भाषा का उपयोग करने और कठबोली भाषा से बचने की भी सिफारिश की जाती है।",
        accept_button_text: "मैं समझता हूं और अपने जोखिम पर उपयोग करने के लिए सहमत हूं",
    },
    provider: "प्रदाता",
    self_help_text: "स्वयं सहायता शिक्षा",
    show_all: "सभी दिखाएं",
    no_record: "कोई रिकॉर्ड नहीं मिला",
    no_heps: "यहां आपको अपनी पुनर्प्राप्ति योजनाएं मिलेंगी जो आपके स्वास्थ्य सेवा प्रदाता द्वारा आपको सौंपे जाने के बाद बनाई गई थीं या हमारे किसी स्वयं-सहायता उपकरण के माध्यम से स्व-सौंपी गई थीं जो आपके लिए उपलब्ध हो सकती हैं। वर्तमान में आपके पास कोई भी असाइन नहीं किया गया है.",
    what_to_do: "क्या करें",
    hold_time: "पकड़ने का समय",
    day_per_week: "सप्ताह में दिन",
    equipment: "उपकरण",
    sets: "सेट्स",
    reps: "रेप्स",
    weight: "वजन",
    in_pounds: "पाउंड में",
    time_per_day: "प्रति दिन समय",
    starting_position: "प्रारंभिक स्थिति",
    description: "विवरण",
    what_you_feel: "आपको क्या महसूस होना चाहिए",
    too_easy: "बहुत आसान",
    too_hard: "बहुत कठिन",
    just_right: "बिल्कुल सही",
    exercise: "व्यायाम",
    education: "शिक्षा",
    back_to_list: "सूची में वापस जाएं",
    about_this_exercise: "इस व्यायाम के बारे में आप क्या सोचते हैं?",
    attachement: "संलग्नक",
    exercise_completed: "व्यायाम को पूर्ण के रूप में चिह्नित करें",
    no_details: "कोई विवरण उपलब्ध नहीं है।",
    hep_details: {
        hard_exercise_modal: {
            title: "व्यायाम के लिए समायोजन की आवश्यकता है।",
            description_line1:
                "यह इस रणनीति में सबसे आसान व्यायाम है, इसलिए हम इस समय एक आसान व्यायाम प्रदान नहीं कर सकते।",
            description_line2:
                "यदि आपको कोई व्यायाम बहुत कठिन लगता है, चिंताएं हैं, या यह सुनिश्चित नहीं है कि आगे क्या करना है, तो तुरंत रुकें और एक स्वास्थ्य पेशेवर या आपके असाइन किए गए प्रदाता से परामर्श करें यदि यह पुनर्प्राप्ति योजना निर्धारित की गई थी।",
            btn_text: "मैंने इन सिफारिशों को पढ़ा और समझा है",
        },
    },
    flash_card: {
        yes_text: "हाँ",
        no_text: "नहीं",
    },
    complete_strategy_modal: {
        title: "बधाई हो!",
        description: "आपने इस सेट के व्यायाम पूरे कर लिए हैं।",
        btn_text: "HEP सूची पर जाएं",
    },
    talk_to_expert: {
        title: "विशेषज्ञ से बात करें",
        breadcrumb: "विशेषज्ञ से बात करें!",
        book_now: "अभी बुक करें",
        powered_by: "द्वारा संचालित",
    },
    find_clinic: {
        title: "क्लिनिक खोजें",
        search: "स्थान दर्ज करें",
        breadcrumb: "क्लिनिक खोजें",
        back_title: "स्थान",
        result_text: "खोज परिणाम",
        pagination_label: "दिखाएं:",
        pagination_text: "प्रविष्टियाँ",
        toggle_list_map_label: "दृश्य:",
        list_text: "सूची",
        map_text: "मानचित्र",
        print_text: "प्रिंट",
        not_found: "कोई क्लिनिक नहीं मिला",
    },
    messages: {
        title: "संदेश",
        new_message: "नया संदेश",
        welcome: "स्वागत है",
        you_are_signed_in_as: "आप इस रूप में साइन इन हैं",
        hi: "नमस्ते",
        you_are_disconnected: "आप वर्तमान में इंटरनेट से डिस्कनेक्ट हैं।",
        practice: "अभ्यास",
        provider: "प्रदाता",
        could_not_send_msg: "संदेश भेजा नहीं जा सका।",
        some_files_removed: "कुछ 100 एमबी से अधिक आकार की फाइलें हटा दी गईं।",
        say_hello: "नमस्ते कहें",
        hello_text: "नमस्ते!",
        start_conversation: "अपनी नई बातचीत शुरू करें",
        send: "भेजें",
        textbox_placeholder: "टाइप करना शुरू करें...",
        search_placeholder: "खोजें...",
        no_provider: "कोई प्रदाता असाइन नहीं किया गया है।",
        no_active_chat:
            "आपके पास कोई सक्रिय चैट नहीं है। नया संदेश बटन पर क्लिक करके एक नई चैट शुरू करें।",
    },
    header_messages: {
        title: "संदेश",
        view_all: "सभी देखें",
        no_messages: "अभी तक कोई संदेश नहीं दिखाने के लिए",
    },
    support: {
        title: "समर्थन",
        tech_support_email: "तकनीकी समर्थन ईमेल",
        other_question: "अन्य प्रश्न",
        section1_title: "क्लिनिकल समर्थन (स्वास्थ्य संबंधी मुद्दे)",
        section1_description:
            "जीवन-धमकाने वाली या चिकित्सा आपात स्थिति के मामले में, तुरंत 911 डायल करें। गैर-आपातकालीन स्वास्थ्य पूछताछ के लिए, कृपया संपर्क करें",
        section2_title: "तकनीकी समर्थन (सॉफ्टवेयर संबंधी मुद्दे)",
        section2_description:
            "हमारा तकनीकी समर्थन सोमवार से शुक्रवार, सुबह 7:00 बजे से शाम 4:00 बजे तक पीएसटी में उपलब्ध है, प्रमुख छुट्टियों को छोड़कर। इन घंटों के बाहर किए गए किसी भी सबमिशन को अगले कार्यदिवस पर संबोधित किया जाएगा।",
        tech_support_email_address: "support@everflexplus.com",
    },
    injury_prevention_plan: {
        title: "चोट की रोकथाम योजना",
        heading: "चोटों से बचाव करना चाहते हैं? एक प्रिवेंशन प्लान आज़माएँ!",
        description:
            "हमारे पास ऐसे व्यायाम हैं जो दर्द और चोट को रोकने में मदद करेंगे और उन क्षेत्रों को मजबूत करेंगे जिन्हें आपको प्रदर्शन सुधारने के लिए विकसित करना है।",
        workplace_label: "कार्यस्थल योजनाएं",
        sport_label: "खेल योजनाएं",
        speciality_label: "विशेषता योजनाएं",
        generalized_label: "सामान्यीकृत योजनाएं",
        start_plan: "योजना शुरू करें",
    },
    footer: {
        copyright_text: "एवरफ्लेक्स प्लस हेल्थ | सर्वाधिकार सुरक्षित",
        pat_no_text:
            "इन उत्पादों को पेट. नं. यूएस 11,587,687 और अन्य लंबित आवेदनों द्वारा कवर किया गया है।",
        about: "के बारे में",
        security_statement: "सुरक्षा विवरण",
        privacy_policy: "गोपनीयता नीति",
        terms_conditions: "नियम और शर्तें",
        contact: "संपर्क करें",
        support: "समर्थन",
        faqs: "पूछे जाने वाले प्रश्न",
        patent_information_text: "पेटेंट जानकारी",
    },
    my_profile: {
        head_title_text: "प्रोफ़ाइल",
        my_account_text: "मेरा खाता",
        tab: {
            account_information_text: "खाता जानकारी",
            communication_preferences_text: "संचार प्राथमिकताएं",
            change_password_text: "पासवर्ड बदलें",
        },
        account_information_form: {
            page_heading_text: "खाता जानकारी",
            first_name_field: {
                label_text: "पहला नाम",
                placeholder_text: "पहला नाम दर्ज करें",
            },
            last_name_field: {
                label_text: "अंतिम नाम",
                placeholder_text: "अंतिम नाम दर्ज करें",
            },
            dob_field: {
                label_text: "जन्म तिथि",
                placeholder_text: "जन्मतिथि (MM/DD/YYYY)",
            },
            email_field: {
                label_text: "ईमेल/उपयोगकर्ता नाम",
                placeholder_text: "ईमेल/उपयोगकर्ता नाम दर्ज करें",
            },
            phone_number_field: {
                label_text: "फोन नंबर",
                placeholder_text: "फोन नंबर दर्ज करें",
            },
            otp_modal: {},
            unverified_email_text: "आपका ईमेल/उपयोगकर्ता नाम सत्यापित नहीं है।",
            unverified_email_btn_text:
                "सत्यापन ईमेल पुनः भेजने के लिए यहां क्लिक करें।",
            verification_link_sent_text:
                "आपके ईमेल पते पर एक नया सत्यापन लिंक भेजा गया है।",
            verification_link_not_sent:
                "कृपया सत्यापित करने के लिए एक ईमेल पता प्रदान करें।",
            submit_btn_text: "जमा करें",
        },
        change_password_form: {
            page_heading_text: "लॉगिन जानकारी",
            current_password_field: {
                label_text: "आपका वर्तमान पासवर्ड",
                placeholder_text: "वर्तमान पासवर्ड दर्ज करें",
            },
            new_password_field: {
                label_text: "नया पासवर्ड",
                placeholder_text: "नया पासवर्ड दर्ज करें",
            },
            confirm_password_field: {
                label_text: "पासवर्ड की पुष्टि करें",
                placeholder_text: "पासवर्ड की पुष्टि दर्ज करें",
            },
            submit_btn_text: "जमा करें",
        },
        communication_preference_form: {
            page_heading_text: "संचार प्राथमिकताएं",
            table_headings: {
                setting_text: "सेटिंग",
                opt_in_text: "सदस्यता लें",
                opt_out_text: "सदस्यता समाप्त करें",
            },
            table_body: {
                email_notification_text: "ईमेल सूचनाएं",
                sms_notification_text: "टेक्स्ट (एसएमएस) सूचनाएं",
            },
            submit_btn_text: "जमा करें",
        },
    },
    password_requirement_text:
        "पासवर्ड में न्यूनतम 8 वर्ण होने चाहिए, जिसमें अपरकेस और लोअरकेस अक्षरों, संख्याओं और प्रतीकों का मिश्रण हो।",
    language: {
        could_not_update: "भाषा को अपडेट नहीं कर सका।",
    },
    error_page: {
        go_back_text: "मुख्य पृष्ठ पर वापस जाएं",
        403: {
            title: "403: निषिद्ध",
            description:
                "क्षमा करें, आपको इस पृष्ठ तक पहुंचने से मना किया गया है।",
        },
        404: {
            title: "404: पृष्ठ नहीं मिला",
            description:
                "क्षमा करें, जिस पृष्ठ की आप तलाश कर रहे थे वह नहीं मिला।",
        },
        500: {
            title: "500: सर्वर त्रुटि",
            description: "उफ़, हमारे सर्वरों पर कुछ गलत हो गया।",
        },
        503: {
            title: "503: सेवा अनुपलब्ध",
            description:
                "क्षमा करें, हम कुछ रखरखाव कर रहे हैं। कृपया जल्द ही वापस जांचें।",
        },
    },

    identify_injury: {
        select: {
            front: "सामने",
            back: "पीठ",
            heading: "मेरी चोट",
            page_title: "मेरी चोट",
            okay: "ठीक है",
            tell_me: "मुझे बताओ",
            about_pain: "अपने दर्द के बारे में",
            answer_question:
                "कुछ सवालों के जवाब दें, और 23 सबसे सामान्य रूप से रिपोर्ट की गई बीमारियों के लिए दर्द को धीरे-धीरे कम करने के लिए साक्ष्य-आधारित और भौतिक चिकित्सकों द्वारा क्यूरेट किए गए व्यायामों की एक व्यक्तिगत श्रृंखला प्राप्त करें। यदि आप किसी चोट के पैटर्न में फिट नहीं होते हैं, तो आप हमारे सामान्यीकृत योजनाओं के साथ स्वयं-सहायता प्राप्त कर सकते हैं, अपने पास एक भौतिक चिकित्सा क्लिनिक पा सकते हैं, या ऑनलाइन एक लाइव प्रदाता के साथ एक यात्रा कर सकते हैं।",
            select_body_part:
                "एक शरीर का हिस्सा चुनें जहां आपको समस्या हो रही है:",
            next: "अगला",
            body_part_not_found: "कोई शरीर का हिस्सा नहीं मिला",
        },
        show: {
            no_question_found: "कोई प्रश्न नहीं मिला",
            next: "अगला",
            heading: "मेरी चोट की पहचान करें",
            page_title: "मेरी चोट की पहचान करें",
            play_video_info:
                "किसी लाइसेंस प्राप्त फिजियोथेरेपिस्ट से इस प्रश्न का अधिक गहन स्पष्टीकरण सुनने के लिए वीडियो चलाएं।",
        },
        body_part: {
            heading: (bodyPart) => `${bodyPart} मूल्यांकन का अन्वेषण करें`,
            sub_heading: (currentBodyPart, newBodyPart) =>
                `${currentBodyPart} व्यायाम से राहत नहीं मिली? संबंधित ${newBodyPart} चिंताओं का आकलन और समाधान करने के लिए पुनर्निर्देशित करें।`,
            explore_plans: "योजनाओं का अन्वेषण करें",
        },
        fallout: {
            heading:
                "आपके द्वारा प्रदान की गई जानकारी के आधार पर, आप हमारे चोट पैटर्न में से एक में नहीं आते हैं।",
            sub_heading:
                "यह अनुशंसा की जाती है कि आप सर्वोत्तम संभव देखभाल सुनिश्चित करने के लिए एक लाइसेंस प्राप्त भौतिक चिकित्सक से बात करें। हम आपकी आवश्यकताओं के अनुरूप निम्नलिखित विकल्प प्रदान करते हैं:",
            talk_to_expert: "विशेषज्ञ से बात करें",
            find_clinic: "क्लिनिक खोजें",
        },
        generalized: {
            heading: "सामान्यीकृत योजनाओं का अन्वेषण करें",
            sub_heading:
                "जो आपको चाहिए वह नहीं मिला? अपने दर्द को प्रबंधित करने या अपने व्यायाम को बढ़ाने के लिए व्यापक विकल्पों की ओर पुनर्निर्देशित करें।",
            explore_plans: "योजनाओं का अन्वेषण करें",
            not_ready_to_speak_heading: "किसी विशेषज्ञ से बात करने के लिए तैयार नहीं हैं? हमारी सामान्य योजनाओं का अन्वेषण करें.",
            not_ready_to_speak_sub_heading: "अपने दर्द या चोट को प्रबंधित करने में सहायता के लिए अधिक विकल्पों के लिए नीचे क्लिक करें",
        },
        hep: {
            heading: "शाबाश 🎉",
            sub_heading:
                "आपकी प्रतिक्रियाओं को सफलतापूर्वक एक स्थापित चोट पैटर्न से मेल किया गया है। हमने आपको इन परिणामों से मेल खाने वाली एक पुनर्प्राप्ति योजना सौंपी है।",
            get_started: "शुरू करें",
        },
        all_body_parts: {
            neck: "गर्दन",
            shoulder: "कंधा",
            elbow_hand: "कोहनी और हाथ",
            elbow_arm: "कोहनी / बांह",
            wrist_hand: "कलाई और हाथ",
            back: "पीठ",
            hip: "कूल्हा",
            knee: "घुटना",
            knee_leg: "घुटना / पैर",
            ankle_foot: "टखना और पैर",
        },
        something_went_wrong_self_help_logs:
            "आपका स्व-लॉग सहेजने में कुछ गलत हो गया।",
    },
    cms_pages: {
        about: {
            breadcrumb_text: "के बारे में",
            head_text: "के बारे में",
            title_text: "के बारे में",
        },
        security_statement: {
            breadcrumb_text: "सुरक्षा विवरण",
            head_text: "सुरक्षा विवरण",
            title_text: "सुरक्षा विवरण",
        },
        privacy: {
            breadcrumb_text: "गोपनीयता नीति",
            head_text: "गोपनीयता नीति",
            title_text: "गोपनीयता नीति",
        },
        terms: {
            breadcrumb_text: "नियम और शर्तें",
            head_text: "नियम और शर्तें",
            title_text: "नियम और शर्तें",
        },
        faq: {
            breadcrumb_text: "अक्सर पूछे जाने वाले प्रश्न",
            head_text: "अक्सर पूछे जाने वाले प्रश्न",
            title_text: "अक्सर पूछे जाने वाले प्रश्न",
        },
        patent: {
            breadcrumb_text: "पेटेंट जानकारी",
            head_text: "पेटेंट जानकारी",
            title_text: "पेटेंट जानकारी",
        },
        no_data_text: "कोई डेटा नहीं मिला!",
    },
    accept_terms: {
        i_agree_text: "मैं ऊपर दिए गए नियमों और शर्तों से सहमत हूं।",
        yes_btn_text: "हाँ",
        no_btn_text: "नहीं",
        terms_and_conditions_text: "नियम और शर्तें",
        terms_updated: "हमारे नियम और शर्तें तब से बदल गई हैं जब आपने उन्हें अंतिम बार स्वीकार किया था",
    },
    hep_restart: {
        check_in: "चेक-इन का समय",
        completed: "आपकी योजना पूरी हो गई है!",
        hey: "नमस्ते,",
        complete_plan_desc: `हम आपके साथ पिछले 21 दिनों में की गई अद्भुत प्रगति का जश्न मनाने के लिए रोमांचित हैं!`,
        take_a_moment: `अब तक आप कैसा महसूस कर रहे हैं, इस पर विचार करने के लिए एक पल लें।`,
        feeling_better: `बेहतर महसूस कर रहे हैं? शानदार!`,
        current_plan_desc: `आप नीचे दिए गए COMPLETE MY CURRENT PLAN बटन पर क्लिक कर सकते हैं। आपके स्वास्थ्य के लिए चीयर्स!`,
        resume_plan_desc: `अपनी योजना जारी रखने और गति बनाए रखने के लिए, नीचे दिए गए RESUME MY PLAN बटन पर क्लिक करें।`,
        clinic_desc: `यदि आपने बहुत अधिक प्रगति का अनुभव नहीं किया है या कुछ अतिरिक्त समर्थन की आवश्यकता है, तो हमने आपकी पीठ थपथपाई है! रुकना ठीक है। हम एक स्वास्थ्य पेशेवर से बात करने की सलाह देते हैं जो व्यक्तिगत मार्गदर्शन प्रदान कर सकता है।`,
        top_priority: `आपकी भलाई हमारी सर्वोच्च प्राथमिकता है।`,
        support_you: `हम हर कदम पर आपका समर्थन करने के लिए यहां हैं।`,
        complete_plan_btn: `मेरी वर्तमान योजना पूरी करें`,
        resume_plan_btn: `मेरी वर्तमान योजना फिर से शुरू करें`,
        clinic_btn: "अपने पास एक स्वास्थ्य पेशेवर खोजें",
        keep_moment: "क्या आप गति बनाए रखना चाहेंगे?",
        is_completed_resume_plan: `नीचे दिए गए RESUME MY PLAN बटन पर क्लिक करें।`,
    },
    header_module: {
        notification_section: {
            popup_heading: "सूचनाएं",
            view_all_text: "सभी देखें",
            no_data_text: "दिखाने के लिए कोई सूचनाएं नहीं हैं।",
        },
        select_preferred_language: "पसंदीदा भाषा चुनें",
        my_account: "मेरा खाता",
        sign_out: "साइन आउट",
        logout_go_back: "लॉगआउट/वापस जाएं",
    },
    notification_center: {
        list: {
            page_title: "सूचना केंद्र सूची",
            page_heading: "सभी सूचनाएं",
            no_record: "कोई सूचनाएं नहीं मिलीं",
        },
        show: {
            page_title: "सूचना केंद्र दिखाएं",
            page_heading: "सूचना विवरण",
        },
        breadcrumb: {
            notification_text: "सभी सूचनाएं",
        },
        action: {
            view: "देखें",
            delete: "हटाएं",
            delete_confirm: "क्या आप वाकई इस सूचना को हटाना चाहते हैं?",
        },
    },
    general_error: "कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें।",
    start_screen: {
        title: "अपना ईमेल या फोन नंबर दर्ज करें",
        heading: "अपना ईमेल या फोन नंबर दर्ज करें",
        email_placeholder: "अपना ईमेल या फोन नंबर दर्ज करें",
        btn_text: "अगला",
        account_disabled_error:
            "आपका खाता अक्षम है, कृपया समर्थन से संपर्क करें।",
        invite_sent:
            "आमंत्रण ईमेल सफलतापूर्वक भेजा गया, कृपया अपना ईमेल जांचें।",
        invite_sent_by_text: "आमंत्रण टेक्स्ट भेजा गया",
        send_invite_by_text: "इसके बजाय टेक्स्ट द्वारा आमंत्रण भेजें",
        account_not_found: "खाता नहीं मिला!",
        choose_account: "जारी रखने के लिए अपना क्लिनिक चुनें!",
    },
    invite_modal: {
        heading: "हमें आपका खाता मिला",
        sub_heading:
            "आपका खाता बनाया गया है, लेकिन साइनअप प्रक्रिया अधूरी है। कृपया अपना पंजीकरण पूरा करने के लिए अपने ईमेल में एक आमंत्रण की जांच करें, या यदि आवश्यक हो तो एक नया आमंत्रण अनुरोध करें।",
        btn_text: "खाता आमंत्रण ईमेल पुनः भेजें",
        btn_text_sms: "खाता आमंत्रण एसएमएस पुनः भेजें",
    },
    preference_modal: {
        acceptance_text: (clinicName) =>
            `मैं अधिकृत करता हूं कि ${clinicName} से निम्नलिखित संचार मुझे प्रदान किए गए इलेक्ट्रॉनिक साधनों द्वारा वितरित किए जाएं। मैं समझता हूं कि कुछ प्रकार के इलेक्ट्रॉनिक संचार सुरक्षित नहीं हो सकते हैं, जिससे अनधिकृत व्यक्तियों को अनुचित प्रकटीकरण का जोखिम हो सकता है।`,
        acceptance_text_2: `मैं उस जोखिम को स्वीकार करने के लिए तैयार हूं, और यदि ऐसा कोई घटना होती है तो अभ्यास को जिम्मेदार नहीं ठहराऊंगा।`,
        sms_notification_text: `टेक्स्ट (एसएमएस) सूचनाएं अनुस्मारक - जब आपके पुनर्प्राप्ति योजना के लिए उपयुक्त हो और आपके प्रदाता द्वारा असाइन किया गया हो`,
        email_notification_text: `ईमेल सूचनाएं (महत्वपूर्ण अपडेट, अन्य स्वास्थ्य-संबंधी जानकारी के अनुस्मारक, और कभी-कभी विपणन संदेश)`,
        marketing_text: "मार्केटिंग ईमेल - अपनी रुचियों और पोर्टल गतिविधि के अनुसार शैक्षिक सामग्री, सेवाएँ, या उत्पाद अपडेट प्राप्त करें। नोट: हम आपकी जानकारी को किसी तीसरे पक्ष को कभी भी नहीं बेचेंगे।",
        clinical_text: "क्लीनिकल ईमेल - आपके उपचार और स्वास्थ्य यात्रा से संबंधित महत्वपूर्ण अपडेट और जानकारी प्राप्त करें।",
        system_text: "सिस्टम नोटिफिकेशन ईमेल - सिस्टम अपडेट और सुरक्षा अलर्ट के बारे में महत्वपूर्ण ईमेल के साथ सूचित रहें।",
        system: {
            header: "सिस्टम नोटिफिकेशन ईमेल",
            subtext: "सिस्टम अपडेट और सुरक्षा अलर्ट के बारे में महत्वपूर्ण ईमेल के साथ सूचित रहें।",
        },
        clinical: {
            header: "क्लीनिकल ईमेल",
            subtext: "आपके उपचार और स्वास्थ्य यात्रा से संबंधित महत्वपूर्ण अपडेट और जानकारी प्राप्त करें।",
        },
        marketing: {
            header: "मार्केटिंग ईमेल",
            subtext: "अपनी रुचियों और पोर्टल गतिविधि के अनुसार शैक्षिक सामग्री, सेवाएँ, या उत्पाद अपडेट प्राप्त करें। नोट: हम आपकी जानकारी को किसी तीसरे पक्ष को कभी भी नहीं बेचेंगे।",
        },
        sms: {
            text: "Text (SMS) Notifications",
        },
        accept_btn_text: "स्वीकार करें",
        submit_btn_text: "जमा करें",
        enter_phone: "अपना मोबाइल फोन नंबर दर्ज करें",
        default_timezone_text: (defaultTimezone) =>
            `हम आपको अपने व्यायाम करने के लिए स्थानीय समयानुसार शाम 6:00 बजे एक टेक्स्ट अनुस्मारक भेजेंगे। ऐसा प्रतीत होता है कि आप ${defaultTimezone} समय क्षेत्र में हैं, क्या यह सही है?`,
        timezone_required: "समय क्षेत्र आवश्यक है।",
        saved: "प्राथमिकताएं सहेजी गई हैं।",
        no_btn_text: "नहीं",
        yes_btn_text: "हाँ",
        select_timezone: "समय क्षेत्र चुनें",
        select_your_timezone: "अपना समय क्षेत्र चुनें",
    },
    set_new_password: {
        heading: "अपना नया पासवर्ड सेट करें",
        sub_heading:
            "बढ़ी हुई सुरक्षा के लिए, कृपया व्यवस्थापक द्वारा प्रदान किया गया अपना वर्तमान पासवर्ड दर्ज करें और फिर अपना नया पासवर्ड सेट करें।",
        current_password_label: "वर्तमान पासवर्ड",
        current_password_placeholder: "वर्तमान पासवर्ड दर्ज करें",
        new_password_label: "नया पासवर्ड",
        new_password_placeholder: "नया पासवर्ड दर्ज करें",
        confirm_password_label: "नया पासवर्ड पुष्टि करें",
        confirm_password_placeholder: "पासवर्ड की पुष्टि करें",
        save_btn_text: "पासवर्ड सहेजें",
    },
    hep_status: {
        completed: "पूरा हुआ",
        self_assigned: "स्वयं असाइन किया गया",
        independent: "स्वतंत्र होम प्रोग्राम",
    },
    level: "स्तर",
    sec: "सेकंड",
    days: "दिन",
    repetitions: "दोहराव",
    lbs: "पाउंड",
    time: "समय",
    allLanguages: {
        en: "अंग्रेज़ी",
        es: "स्पेनिश",
        fr: "फ्रेंच",
        zh: "चीनी (सरलीकृत)",
        "zh-TW": "चीनी (पारंपरिक)",
        tl: "टैगालोग",
        vi: "वियतनामी",
        ar: "अरबी",
        ko: "कोरियाई",
        ru: "रूसी",
        hi: "हिंदी",
        sw: "स्वाहिली",
    },
    outcomes: {
        next: "आगे",
        back: "पीछे",
        continue: "जारी रखें",
        finish: "समाप्त करें",
        response_title: "आपकी प्रतिक्रिया के लिए धन्यवाद।",
        groc: {
            title: "समय के साथ अपनी प्रगति का मूल्यांकन करें",
            subtitle: "अपने प्रारंभिक दौरे या उपचार की शुरुआत की तुलना में अपनी स्थिति पर विचार करें। वह विकल्प चुनें जो इस दौरान आपके समग्र परिवर्तन का सबसे अच्छा वर्णन करता हो। सकारात्मक और नकारात्मक दोनों परिवर्तनों पर ध्यान केंद्रित करें, जिसमें आपकी स्थिति के वे पहलू शामिल हैं जो बेहतर या खराब हुए हैं।",
            text_neg_7: "बहुत ज्यादा खराब",
            text_neg_4: "खराब",
            text_0: "अपरिवर्तित",
            text_4: "बेहतर",
            text_7: "बहुत ज्यादा बेहतर",
        },
        pass: {
            subtitle: "आपके लक्षणों की तीव्रता, गतिविधियों में कठिनाई, और आपकी स्थिति का दैनिक जीवन पर प्रभाव देखते हुए, यदि आपकी प्रगति अभी जैसी ही बनी रहती है, तो क्या आप अपनी वर्तमान स्थिति को स्वीकार्य मानेंगे?",
            yes: "हाँ",
            no: "नहीं",
        },
        psfs: {
            title: "अपनी दैनिक गतिविधि चुनौतियों का आकलन करें",
            subtitle: "कृपया 3 महत्वपूर्ण गतिविधियाँ सूचीबद्ध करें जिन्हें आप करने में असमर्थ हैं, या अपनी स्थिति के कारण कठिनाई का सामना कर रहे हैं। प्रत्येक गतिविधि के लिए, कृपया आज की तारीख के अनुसार अपनी वर्तमान कठिनाई स्तर का एक स्कोर प्रदान करें।",
            repeat_subtitle: "अपनी प्रारंभिक यात्रा या उपचार की शुरुआत की तुलना में अपनी स्थिति पर विचार करें। प्रत्येक गतिविधि के लिए, कृपया आज के अनुसार अपनी कठिनाई के वर्तमान स्तर के लिए एक गतिविधि स्कोर प्रदान करें।",
            text_0: "प्रदर्शन करने में असमर्थ",
            text_10: "पहले की तरह प्रदर्शन कर सकते हैं",
            activity: "गतिविधि",
            text_0: "प्रदर्शन करने में असमर्थ",
            text_10: "पहले की तरह प्रदर्शन कर सकते हैं",
        }
    }
};
